import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {
  mobile: boolean = false;

  @Input() value: number;

  constructor() {
  }

  ngOnInit(): void {
    if (window.screen.width <= 1000) { // 768px portrait
      this.mobile = true;
    }
  }

}
